{
    "ExcludeheldtimeLabel": "Escludere il tempo di permanenza:",
    "TalkTime_SectionHeader": "Tempo di conversazione",
    "TalkTime_SectionPara": "È possibile scegliere se le statistiche relative al tempo di conversazione della chiamata debbano escludere dalla logica di calcolo il tempo di attesa della chiamata.",
    "NAME": "TalkTime"
}